<div #tabtop (click)="initiated()">
  <nb-tabset>
    <nb-tab *ngFor="let tab of item.tabs" [tabTitle]="tab.translation_key||tab.heading| translation|translationFromString | transformText :tab?.text_transform">
          <app-rendered
                        [childview]="item.childview || childview"
                        [paramprefix]="item.paramprefix"
                        [info]="info"
                        *ngFor="let it of tab.content" [item]="it"
                        [arr]="tab.content" [data]="data"
                        (deleteDataEvent)="delete($event)"
                        (openViewEvent)="openView($event)"
                        (moveHandler)="openMove()"
                        (openLinkEvent)="openLink($event)">

          </app-rendered>
         </nb-tab>
  </nb-tabset>
</div>
